<template>
  <icon-button
    :class="buttonClasses"
    class="button is-rounded paragraph-m jobs-scroll-button"
    @click="$emit('click')">
    <div slot="icon"><slot name="icon"></slot></div>
    <div slot="text">{{ buttonText }}</div>
  </icon-button>
</template>

<script>

import IconButton from '@/common/IconButton';

export default {
  props: {
    buttonText: String,
    buttonClasses: String
  },
  components: {
    IconButton
  }
};
</script>

<style lang="scss" scoped>
.button.jobs-scroll-button {
  margin: 0 auto;
  max-width: 152px;
  -webkit-tap-highlight-color: transparent;

  &.filter-results {
    .btn-item:first-child div {
      height: 16px;

      /deep/ path {
        fill: var(--white);
      }
    }
  }
}
</style>
